import { useEffect, useState, useRef } from 'react';
import './App.css';

// ===== EXACT ORIGINAL WEBSITE IMAGE URLs =====
const LOGO = '/logotires.png';

const TIRE_DIAGRAM = 'https://themes.webdevia.com/tires-wheels/wp-content/uploads/revslider/dark_home/tire-sizes.png';
const ABOUT_IMG = 'https://themes.webdevia.com/tires-wheels/wp-content/uploads/2015/09/pic-1.png';

const BRAND_CATS = [
  { name: 'DUNLOP',      desc: 'High performance tires for every road',      img: '/images/1956515 R1 Dunlop brand.jpeg' },
  { name: 'YOKOHAMA',    desc: 'Precision engineering, superior grip',        img: '/images/2055516 Advan DB V553 Yokohama brand.jpeg' },
  { name: 'BRIDGESTONE', desc: 'World\'s leading tire manufacturer',          img: '/images/2055516 Techno Bridgestone brand.jpeg' },
  { name: 'CONTINENTAL', desc: 'Safety and innovation in every mile',         img: '/images/2055516 continental brands.jpeg' },
  { name: 'CHINA',       desc: 'Affordable quality for everyday driving',     img: '/images/1557012 tracmax China brand.jpeg' },
];

const PRODUCTS = [
  { id:1,  name:'Dunlop R1 – 155/70/12',           brand:'Dunlop',      img:'/images/1557012 R1 Dunlop brand.jpeg' },
  { id:2,  name:'Yokohama ES32 – 155/70/12',        brand:'Yokohama',    img:'/images/1557012 Es 32 Yokohama.jpeg' },
  { id:3,  name:'Bridgestone Techno – 155/70/12',   brand:'Bridgestone', img:'/images/1557012 Techno Bridgestone brand.jpeg' },
  { id:4,  name:'Continental – 155/70/12',           brand:'Continental', img:'/images/1557012 Continental brands.jpeg' },
  { id:5,  name:'Tracmax China – 155/70/12',         brand:'China',       img:'/images/1557012 tracmax China brand.jpeg' },
  { id:6,  name:'Yokohama ES32 – 185/65/15',        brand:'Yokohama',    img:'/images/1856515 ES 32 Yokohama brand.jpeg' },
  { id:7,  name:'Dunlop R1 – 185/65/15',            brand:'Dunlop',      img:'/images/1856515 R1 Dunlop brand.jpeg' },
  { id:8,  name:'Bridgestone Techno – 185/65/15',   brand:'Bridgestone', img:'/images/1856515 Techno Bridgestone brand.jpeg' },
  { id:9,  name:'Tracmax China – 185/65/15',         brand:'China',       img:'/images/1856515 Tracmax china brand.jpeg' },
  { id:10, name:'Continental – 186/65/15',           brand:'Continental', img:'/images/1866515 continental brand.jpeg' },
  { id:11, name:'Continental – 195/65/15',           brand:'Continental', img:'/images/1956515 continental brands.jpeg' },
  { id:12, name:'Dunlop R1 – 195/65/15',            brand:'Dunlop',      img:'/images/1956515 R1 Dunlop brand.jpeg' },
  { id:13, name:'Tracmax China – 195/65/15',         brand:'China',       img:'/images/1956515 tracmax China brand.jpeg' },
  { id:14, name:'Bridgestone Techno – 196/65/15',   brand:'Bridgestone', img:'/images/1966515 Techno Bridgestone brand.jpeg' },
  { id:15, name:'Yokohama Advan DB V553 – 205/55/16', brand:'Yokohama',  img:'/images/2055516 Advan DB V553 Yokohama brand.jpeg' },
  { id:16, name:'Continental – 205/55/16',           brand:'Continental', img:'/images/2055516 continental brands.jpeg' },
  { id:17, name:'Bridgestone Techno – 205/55/16',   brand:'Bridgestone', img:'/images/2055516 Techno Bridgestone brand.jpeg' },
  { id:18, name:'Tracmax China – 205/55/16',         brand:'China',       img:'/images/2055516 Tracmax China brand.jpeg' },
  { id:19, name:'Yokohama ES32 – 205/65/15',        brand:'Yokohama',    img:'/images/2056515 ES 32 Yokohama.jpeg' },
  { id:20, name:'Dunlop R1 – 205/65/15',            brand:'Dunlop',      img:'/images/2056515 R1 Dunlop bra.jpeg' },
];

const WHY_FEATURES = [
  {
    icon: 'https://themes.webdevia.com/tires-wheels/wp-content/uploads/2015/09/icon_1.png',
    title: '100% Guaranteed Fitment',
    text: 'Whatever your budget and whatever the size of car you are looking for, we are sure we can help you find what is right for you. To fully appreciate the range of cars we have on offer please visit one of our showrooms.',
  },
  {
    icon: 'https://themes.webdevia.com/tires-wheels/wp-content/uploads/2015/09/icon_2.png',
    title: "We're Tire Experts",
    text: 'Whatever your budget and whatever the size of car you are looking for, we are sure we can help you find what is right for you. To fully appreciate the range of cars we have on offer please visit one of our showrooms.',
  },
  {
    icon: 'https://themes.webdevia.com/tires-wheels/wp-content/uploads/2015/09/icon_3.png',
    title: 'Free Shipping',
    text: 'Whatever your budget and whatever the size of car you are looking for, we are sure we can help you find what is right for you. To fully appreciate the range of cars we have on offer please visit one of our showrooms.',
  },
  {
    icon: 'https://themes.webdevia.com/tires-wheels/wp-content/uploads/2015/09/icon_5.png',
    title: '24/7 Support',
    text: 'Whatever your budget and whatever the size of car you are looking for, we are sure we can help you find what is right for you. To fully appreciate the range of cars we have on offer please visit one of our showrooms.',
  },
];

const BLOG_POSTS = [
  {
    id:1,
    img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=900&q=80',
    date: 'January 15, 2025',
    author: 'Imperial Tyres',
    category: 'Tire Tips',
    title: 'How to Choose the Right Tire Size for Your Car',
    excerpt: 'Choosing the wrong tire size can affect your car\'s handling, fuel efficiency and safety. Learn how to read the sidewall and pick the perfect fit for your vehicle.',
    content: [
      { type:'p', text:'Picking the correct tire size is one of the most important decisions you can make for your vehicle. The right size ensures proper handling, braking performance, fuel efficiency and overall safety — especially on Pakistan\'s diverse road conditions.' },
      { type:'h3', text:'How to Read the Tire Sidewall' },
      { type:'p', text:'Every tire has a size code printed on the sidewall. For example: 185/65 R15. Here\'s what each number means:' },
      { type:'list', items:[
        '185 — Tire width in millimetres (wider = more grip)',
        '65 — Aspect ratio (sidewall height as % of width)',
        'R — Radial construction (standard for all modern cars)',
        '15 — Rim diameter in inches',
      ]},
      { type:'h3', text:'Why the Right Size Matters' },
      { type:'p', text:'Using the wrong size can cause the speedometer to read incorrectly, affect suspension geometry and even void your vehicle warranty. Always stick to the manufacturer\'s recommended size unless advised by a professional.' },
      { type:'h3', text:'Popular Sizes at Imperial Tyres #1' },
      { type:'p', text:'At our shop in Saddar Rawalpindi, we stock the most popular sizes for common Pakistani vehicles including Suzuki Mehran, Alto, Cultus, Honda City, Civic, Toyota Corolla and more. Come in or call 0300-3456447 for advice on the right size for your car.' },
      { type:'tip', text:'Tip: Always replace tires in pairs (both fronts or both rears) to maintain balanced handling and even wear.' },
    ],
  },
  {
    id:2,
    img: 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=900&q=80',
    date: 'March 5, 2025',
    author: 'Imperial Tyres',
    category: 'Maintenance',
    title: 'Top 5 Signs Your Tires Need Immediate Replacement',
    excerpt: 'Worn-out tires are a major safety hazard on Pakistani roads. Here are the 5 warning signs every driver should know before it\'s too late.',
    content: [
      { type:'p', text:'Tires are the only part of your car that contacts the road. Worn or damaged tires dramatically increase your risk of accidents, especially on Rawalpindi\'s wet roads in monsoon season. Here are 5 warning signs you must never ignore.' },
      { type:'h3', text:'1. Tread Depth Below 2mm' },
      { type:'p', text:'The legal minimum tread depth is 1.6mm, but we recommend replacing at 2mm. Use a coin to test — if you can see the top of the coin above the tread, it\'s time for new tires.' },
      { type:'h3', text:'2. Visible Cracks or Bulges' },
      { type:'p', text:'Sidewall cracks or bulges indicate the internal structure is failing. A bulge means a blowout could happen at any moment — replace the tire immediately.' },
      { type:'h3', text:'3. Vibration While Driving' },
      { type:'p', text:'Unusual vibration through the steering wheel can indicate uneven tire wear, imbalanced wheels or internal tire damage. Get it checked right away.' },
      { type:'h3', text:'4. Frequent Punctures' },
      { type:'p', text:'If you\'re getting punctures more often than normal, the tread is too worn to protect against road hazards. It\'s more cost-effective to replace the tire than keep repairing it.' },
      { type:'h3', text:'5. Tires Are Over 5 Years Old' },
      { type:'p', text:'Even if a tire looks fine, rubber degrades over time. After 5 years, have them inspected annually. After 10 years, replace them regardless of appearance.' },
      { type:'tip', text:'Visit Imperial Tyres #1 at Kashmir Road Shop 128-B, Saddar Rawalpindi for a free visual tire inspection. Call 0300-3456447.' },
    ],
  },
  {
    id:3,
    img: 'https://images.unsplash.com/photo-1612825173281-9a193378527e?w=900&q=80',
    date: 'May 20, 2025',
    author: 'Imperial Tyres',
    category: 'Brand Guide',
    title: 'Dunlop vs Yokohama vs Bridgestone — Which is Best for Pakistan?',
    excerpt: 'We compare the top tire brands available at Imperial Tyres #1 to help you decide which brand suits your car, budget and driving conditions in Rawalpindi.',
    content: [
      { type:'p', text:'We stock all three of these top international tire brands at Imperial Tyres #1. Each has its own strengths depending on your vehicle, budget and the type of driving you do in Pakistan.' },
      { type:'h3', text:'Dunlop R1 — Best All-Rounder' },
      { type:'p', text:'Dunlop is one of the most trusted brands in Pakistan. The R1 range offers excellent wet and dry grip, a comfortable ride and good longevity at a competitive price point. Available in sizes 155/70/12, 185/65/15, 195/65/15 and 205/65/15 at our shop.' },
      { type:'h3', text:'Yokohama ES32 & Advan DB V553 — Best for Performance' },
      { type:'p', text:'Yokohama tires deliver superior handling and a quieter ride. The ES32 is ideal for everyday city driving while the Advan DB V553 suits drivers who want better cornering and highway stability. Great choice for Honda Civic, Corolla and City owners.' },
      { type:'h3', text:'Bridgestone Techno — Best Build Quality' },
      { type:'p', text:'Bridgestone is the world\'s largest tire manufacturer for good reason. The Techno range offers outstanding durability, heat resistance and consistent performance in both urban and motorway driving conditions. Excellent for long-distance drivers on Motorway M-2.' },
      { type:'h3', text:'Our Recommendation' },
      { type:'p', text:'For most Pakistani drivers on a mid-range budget, Dunlop R1 gives the best value. For those who want premium performance, go with Yokohama. For maximum durability, Bridgestone Techno is the top choice.' },
      { type:'tip', text:'Not sure which brand is right for your car? Call us at 0300-3456447 or WhatsApp and we\'ll give you honest advice at no charge.' },
    ],
  },
];

const NAV_ITEMS = [
  { label: 'HOME', href: '#home' },
  { label: 'ABOUT US', href: '#about' },
  { label: 'SERVICES', href: '#services', drop: [
    { label: 'Wheels & Tire Protection',            page: 'svc-protection' },
    { label: 'Tire Rotation Services',              page: 'svc-rotation' },
    { label: 'Tire Alignment Services',             page: 'svc-alignment' },
    { label: 'Roadside Assistance',                 page: 'svc-roadside' },
    { label: 'Tire & Wheel Service Coupons',        page: 'svc-coupons' },
  ]},
  { label: 'BLOG', href: '#blog' },
  { label: 'PAGES', href: '#home', drop: [
    { label: 'About Us',    page: 'page-about' },
    { label: 'Our Team',    page: 'page-team' },
    { label: 'FAQ',         page: 'page-faq' },
    { label: 'Testimonials',page: 'page-testimonials' },
  ]},
  { label: 'SHOP', href: '#products' },
  { label: 'CONTACT US', href: '#contact' },
];

const TIRE_WIDTHS = [155,165,175,185,195,205,215,225,235,245,255,265];
const ASPECT_RATIOS = [35,40,45,50,55,60,65,70,75,80];
const RIM_SIZES = [12,13,14,15,16,17,18,19,20];

const BRAND_PATTERNS = {
  ALL:         [],
  YOKOHAMA:    ['Advan V553','Advan V61','ES 32','GT 50','GT 51'],
  DUNLOP:      ['R1','Deraza'],
  BRIDGESTONE: ['Techno'],
  CONTINENTAL: [],
  CHINA:       [],
};

// ===== COUNTER =====
function useCounter(target, active) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active) return;
    let cur = 0;
    const step = target / (1800 / 16);
    const t = setInterval(() => {
      cur += step;
      if (cur >= target) { setCount(target); clearInterval(t); }
      else setCount(Math.floor(cur));
    }, 16);
    return () => clearInterval(t);
  }, [target, active]);
  return count;
}

export default function App() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileDropOpen, setMobileDropOpen] = useState({});
  const [brandFilter, setBrandFilter] = useState('ALL');
  const [patternFilter, setPatternFilter] = useState('ALL');
  const [tireWidth, setTireWidth] = useState('155');
  const [aspectRatio, setAspectRatio] = useState('70');
  const [rimSize, setRimSize] = useState('12');
  const [finderResults, setFinderResults] = useState(null);
  const [finderDrop, setFinderDrop] = useState(null); // 'brand'|'pattern'|'width'|'ratio'|'rim'
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [statsActive, setStatsActive] = useState(false);
  const statsRef = useRef(null);

  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const searchInputRef = useRef(null);
  const [vidIdx, setVidIdx] = useState(0);
  const [vidPlaying, setVidPlaying] = useState(false);
  const videoRef = useRef(null);
  const [quickView, setQuickView] = useState(null);
  const [currentPage, setCurrentPage] = useState(null);
  const [blogPost, setBlogPost] = useState(null); // holds full blog post object

  const c1 = useCounter(1500, statsActive);
  const c2 = useCounter(500, statsActive);
  const c3 = useCounter(25, statsActive);
  const c4 = useCounter(48, statsActive);

  // Stats observer
  useEffect(() => {
    const el = statsRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setStatsActive(true); }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  // Scroll-to-top
  useEffect(() => {
    const fn = () => setShowScrollTop(window.scrollY > 400);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  // Search data from products + blog + sections
  const SEARCH_DATA = [
    ...PRODUCTS.map(p => ({ title: p.name, type: p.brand, img: p.img, product: p })),
  ];

  const searchResults = searchQuery.trim().length > 0
    ? SEARCH_DATA.filter(item => item.title.toLowerCase().includes(searchQuery.toLowerCase()))
    : SEARCH_DATA;

  const handleSearchClick = (item) => {
    closeSearch();
    if (item.product) {
      setCurrentPage(null);
      setTimeout(() => {
        const el = document.getElementById('products');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(() => setQuickView(item.product), 400);
      }, 100);
    }
  };

  const openSearch = () => {
    setSearchOpen(true);
    setTimeout(() => searchInputRef.current && searchInputRef.current.focus(), 100);
  };

  const closeSearch = () => { setSearchOpen(false); setSearchQuery(''); };

  const handleFinder = (e) => {
    e.preventDefault();
    const sizeKey = `${tireWidth}/${aspectRatio}/${rimSize}`;
    const matched = PRODUCTS.filter(p => {
      const name = p.name.toLowerCase();
      const sizeMatch = name.includes(sizeKey.toLowerCase());
      const brandMatch = brandFilter === 'ALL' || p.brand.toUpperCase() === brandFilter;
      const patternMatch = patternFilter === 'ALL' || name.includes(patternFilter.toLowerCase());
      return sizeMatch && brandMatch && patternMatch;
    });
    setFinderResults({ size: `${tireWidth}/${aspectRatio} R${rimSize}`, brand: brandFilter, pattern: patternFilter, items: matched });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const PAGE_CONTENT = {
    'svc-protection': {
      title: 'Wheels & Tire Protection',
      icon: 'fas fa-shield-alt',
      hero: 'Protect Your Investment',
      desc: 'At Imperial Tyres #1, we offer comprehensive wheel and tire protection packages that keep your tires in top condition and extend their lifespan significantly.',
      items: [
        { icon:'fas fa-shield-alt',   title:'Tire Road Hazard Protection', text:'Coverage against punctures, blowouts, and damage from road hazards including nails, glass, potholes and debris.' },
        { icon:'fas fa-sync-alt',     title:'Free Tire Rotation',          text:'Regular tire rotation every 5,000–8,000 km ensures even wear across all four tires and maximizes tire life.' },
        { icon:'fas fa-wrench',       title:'Tire Repair Service',         text:'Professional plug and patch repairs for punctured tires using industry-standard techniques and materials.' },
        { icon:'fas fa-star',         title:'Rim Protection',              text:'Guard your alloy and steel rims against kerb damage, corrosion and road impact with our rim protection service.' },
        { icon:'fas fa-check-circle', title:'Nitrogen Inflation',          text:'Nitrogen-filled tires maintain pressure longer, improve fuel efficiency and reduce heat build-up at high speeds.' },
        { icon:'fas fa-car',          title:'Full Wheel Balancing',        text:'Eliminate vibrations and uneven wear with precision computerized wheel balancing on all tire sizes.' },
      ]
    },
    'svc-rotation': {
      title: 'Tire Rotation Services',
      icon: 'fas fa-sync-alt',
      hero: 'Maximize Tire Life',
      desc: 'Tire rotation is one of the most important maintenance services you can do for your tires. Our expert technicians at Imperial Tyres #1 rotate all tire sizes quickly and professionally.',
      items: [
        { icon:'fas fa-sync-alt',        title:'Front-to-Back Rotation',        text:'The most common rotation pattern — moves front tires straight back and rear tires straight to the front.' },
        { icon:'fas fa-exchange-alt',    title:'Cross Rotation',                text:'Diagonal cross pattern used for directional tires to ensure maximum even wear across all four corners.' },
        { icon:'fas fa-tachometer-alt',  title:'Wear Inspection',               text:'Every rotation includes a free visual inspection of tire tread depth, sidewall condition and air pressure check.' },
        { icon:'fas fa-calendar-check',  title:'Recommended Every 8,000 km',    text:'We recommend rotation every 8,000 km or at every oil change service interval for best results.' },
        { icon:'fas fa-coins',           title:'Affordable Pricing',             text:'Competitive pricing on all tire rotation services. Call us for current rates and package deals.' },
        { icon:'fas fa-clock',           title:'Quick Turnaround',              text:'Tire rotation typically completed in 30–45 minutes. Walk-in customers welcome at our Saddar shop.' },
      ]
    },
    'svc-alignment': {
      title: 'Tire Alignment Services',
      icon: 'fas fa-arrows-alt-h',
      hero: 'Drive Straight, Drive Safe',
      desc: 'Proper wheel alignment is critical for tire longevity, fuel efficiency and vehicle safety. Imperial Tyres #1 provides precision computerized alignment for all vehicle types.',
      items: [
        { icon:'fas fa-arrows-alt-h',        title:'4-Wheel Alignment',             text:'Full four-wheel computerized alignment checks and corrects camber, caster and toe angles on all wheels.' },
        { icon:'fas fa-car',                 title:'Front-End Alignment',           text:'Two-wheel front alignment service ideal for vehicles with solid rear axles and older suspension designs.' },
        { icon:'fas fa-exclamation-triangle',title:'Signs You Need Alignment',      text:'Pulling to one side, uneven tire wear, steering wheel vibration or car drifting after hitting a pothole.' },
        { icon:'fas fa-gas-pump',            title:'Improved Fuel Economy',         text:'Correctly aligned wheels reduce rolling resistance, which directly improves your vehicle fuel efficiency.' },
        { icon:'fas fa-tools',               title:'Suspension Check',              text:'Every alignment includes a complimentary inspection of suspension components, tie rods and steering linkage.' },
        { icon:'fas fa-check',               title:'Manufacturer Specifications',   text:"All alignments are set to your vehicle manufacturer's exact specifications for optimal performance." },
      ]
    },
    'svc-roadside': {
      title: 'Roadside Assistance',
      icon: 'fas fa-truck',
      hero: 'We Come to You',
      desc: "Stranded on the road with a flat tire? Imperial Tyres #1 offers fast roadside tire assistance across Rawalpindi. Just call us and we'll be there.",
      items: [
        { icon:'fas fa-phone',           title:'24/7 Emergency Line',     text:'Call 0300-3456447 any time for emergency roadside tire assistance in Rawalpindi and surrounding areas.' },
        { icon:'fas fa-truck',           title:'Mobile Tire Fitting',     text:'Our mobile unit carries a range of common tire sizes and can fit a replacement tire at your location.' },
        { icon:'fas fa-wrench',          title:'On-Site Puncture Repair', text:'Minor punctures can often be repaired on the spot, getting you back on the road quickly and safely.' },
        { icon:'fas fa-map-marker-alt',  title:'Coverage Area',           text:'We cover Rawalpindi city, Saddar, Murree Road, GT Road and surrounding areas within 15 km radius.' },
        { icon:'fas fa-clock',           title:'Fast Response',           text:'We aim to reach you within 30–60 minutes depending on location and traffic conditions.' },
        { icon:'fab fa-whatsapp',        title:'WhatsApp Us',             text:'Send your location on WhatsApp to 0300-3456447 and our team will be dispatched immediately.' },
      ]
    },
    'svc-coupons': {
      title: 'Tire & Wheel Service Coupons',
      icon: 'fas fa-tag',
      hero: 'Current Deals & Offers',
      desc: 'Save on your next tire and wheel service at Imperial Tyres #1. Visit our shop at Kashmir Road Shop 128-B, Saddar Rawalpindi or call for the latest offers.',
      items: [
        { icon:'fas fa-tag',           title:'Buy 3 Get 1 Free',          text:'Purchase any 3 tires of the same brand and size and get the 4th tire absolutely free. Limited time offer.' },
        { icon:'fas fa-sync-alt',      title:'Free Rotation With Purchase',text:'Get a free tire rotation service with every set of 4 new tires purchased from our shop.' },
        { icon:'fas fa-balance-scale', title:'Free Balancing',            text:'All 4 wheels balanced free of charge when you purchase a full set of tires from Imperial Tyres #1.' },
        { icon:'fas fa-percent',       title:'10% Off Bridgestone Range', text:'Special discount on the full Bridgestone Techno range this season. Ask in-store for qualifying sizes.' },
        { icon:'fas fa-star',          title:'Dunlop Seasonal Deal',      text:'Dunlop R1 tires at special pricing for 185/65/15 and 205/65/15 sizes. While stocks last.' },
        { icon:'fas fa-phone',         title:'Call for Latest Offers',    text:'Offers change regularly. Call 0300-3456447 or WhatsApp to ask about current promotions and bulk pricing.' },
      ]
    },
    'page-about': {
      title: 'About Imperial Tyres #1',
      icon: 'fas fa-store',
      hero: 'Your Trusted Tire Shop in Rawalpindi',
      desc: "Imperial Tyres #1 has been serving Rawalpindi's drivers from our shop on Kashmir Road, Saddar. We stock a wide range of top tire brands at competitive prices.",
      items: [
        { icon:'fas fa-map-marker-alt', title:'Our Location',    text:'Kashmir Road Shop 128-B, Saddar Rawalpindi — conveniently located in the heart of the city.' },
        { icon:'fas fa-phone',          title:'Contact Number',  text:"Call or WhatsApp us at 0300-3456447. We're happy to advise on the right tire for your vehicle." },
        { icon:'fas fa-envelope',       title:'Email Us',        text:'Send your enquiries to Imperialtyres4@gmail.com and we will respond as soon as possible.' },
        { icon:'fas fa-award',          title:'Top Brands',      text:'We stock Dunlop, Yokohama, Bridgestone, Continental and China brand tires across all popular sizes.' },
        { icon:'fas fa-users',          title:'Expert Team',     text:'Our experienced tire technicians help you choose the right tire based on your vehicle, budget and driving style.' },
        { icon:'fas fa-star',           title:'Customer Trust',  text:'Hundreds of satisfied customers across Rawalpindi trust Imperial Tyres #1 for quality tires and honest service.' },
      ]
    },
    'page-team': {
      title: 'Our Team',
      icon: 'fas fa-users',
      hero: 'The People Behind Imperial Tyres #1',
      desc: 'Our professional team at Imperial Tyres #1 is dedicated to giving you the best tire advice, fitting service and after-sales support in Rawalpindi.',
      items: [
        { icon:'fas fa-user-tie',  title:'Owner & Tire Expert',      text:'With over 15 years of experience in the tire industry, our owner personally ensures every customer gets the right tire.' },
        { icon:'fas fa-wrench',    title:'Senior Tire Technician',   text:'Our lead technician specializes in fitting, balancing and alignment for all vehicle types from hatchbacks to SUVs.' },
        { icon:'fas fa-headset',   title:'Sales & Customer Service', text:'Our friendly sales staff are knowledgeable about all the brands we stock and are happy to help you decide.' },
        { icon:'fas fa-truck',     title:'Mobile Service Team',      text:'Our mobile roadside team is trained to handle emergency tire replacements quickly and safely on the road.' },
        { icon:'fas fa-tools',     title:'Workshop Staff',           text:'Our workshop team handles wheel balancing, rotation and alignment to manufacturer specifications.' },
        { icon:'fas fa-phone',     title:'Get in Touch',             text:'Contact us at 0300-3456447 or visit Kashmir Road Shop 128-B, Saddar Rawalpindi.' },
      ]
    },
    'page-faq': {
      title: 'Frequently Asked Questions',
      icon: 'fas fa-question-circle',
      hero: 'Got Questions? We Have Answers',
      desc: 'Find answers to the most common questions about tires, services and our shop at Imperial Tyres #1, Kashmir Road, Saddar Rawalpindi.',
      items: [
        { icon:'fas fa-question-circle', title:'How do I know which tire size I need?',  text:"Your tire size is printed on the sidewall of your current tire (e.g. 185/65 R15). You can also check your vehicle's door sticker or owner manual." },
        { icon:'fas fa-question-circle', title:'How long does tire fitting take?',        text:'A standard 4-tire fitting with balancing typically takes 45–60 minutes at our shop. Walk-in customers are welcome.' },
        { icon:'fas fa-question-circle', title:'Do you offer mobile tire fitting?',       text:'Yes — call 0300-3456447 for roadside or on-location tire fitting in the Rawalpindi area.' },
        { icon:'fas fa-question-circle', title:'Which brand is best for Pakistan roads?', text:'Dunlop, Yokohama and Bridgestone offer excellent performance. Tracmax China brand is great value for budget-conscious drivers.' },
        { icon:'fas fa-question-circle', title:'How often should I rotate my tires?',     text:'We recommend rotation every 8,000 km or at every oil change. Regular rotation significantly extends tire life.' },
        { icon:'fas fa-question-circle', title:'Do you repair punctures?',                text:'Yes — we repair punctures using professional plug-and-patch methods. Call ahead or walk in to our Saddar shop.' },
      ]
    },
    'page-testimonials': {
      title: 'Customer Testimonials',
      icon: 'fas fa-star',
      hero: 'What Our Customers Say',
      desc: "Don't just take our word for it. Here's what real customers from Rawalpindi say about Imperial Tyres #1.",
      items: [
        { icon:'fas fa-quote-left', title:'Ahmed R. — Rawalpindi',  text:'"Excellent service! Got 4 Bridgestone tires fitted in under an hour. Very professional and honest pricing. Highly recommended."' },
        { icon:'fas fa-quote-left', title:'Usman K. — Saddar',      text:"\"I've been going to Imperial Tyres for 3 years. They always have the right size in stock and the team is very knowledgeable.\"" },
        { icon:'fas fa-quote-left', title:'Bilal M. — Murree Road', text:'"Had a roadside flat late at night. Called 0300-3456447 and they came within 40 minutes. Great service."' },
        { icon:'fas fa-quote-left', title:'Faisal A. — Chaklala',   text:'"Bought Yokohama ES32 tires. Very smooth ride. The staff helped me choose the right size for my Corolla."' },
        { icon:'fas fa-quote-left', title:'Tariq H. — Bahria Town', text:'"Best tire shop in Rawalpindi. Competitive prices, genuine brands and quick fitting. Will definitely come back."' },
        { icon:'fas fa-quote-left', title:'Imran S. — Peshawar Rd', text:'"Got alignment and balancing done. The difference was immediately noticeable. Very reasonable charges."' },
      ]
    },
  };

  const renderPage = () => {
    const pg = PAGE_CONTENT[currentPage];
    if (!pg) return null;
    return (
      <div className="tw-inner-page">
        <div className="tw-page-hero">
          <div className="tw-page-hero-overlay"></div>
          <div className="tw-page-hero-content">
            <span className="tw-section-sub"><i className={pg.icon}></i>&nbsp; Imperial Tyres #1</span>
            <h1>{pg.title}</h1>
            <div className="tw-page-breadcrumb">
              <span onClick={() => { setCurrentPage(null); window.scrollTo({top:0,behavior:'smooth'}); }} style={{cursor:'pointer'}}>Home</span>
              <i className="fas fa-chevron-right"></i>
              <span>{pg.title}</span>
            </div>
          </div>
        </div>
        <div className="tw-page-body">
          <div className="tw-container">
            <div className="tw-page-intro">
              <h2>{pg.hero}</h2>
              <p>{pg.desc}</p>
            </div>
            <div className="tw-page-grid">
              {pg.items.map((item, i) => (
                <div className="tw-page-card" key={i}>
                  <div className="tw-page-card-icon"><i className={item.icon}></i></div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
            <div className="tw-page-cta">
              <h3>Ready to get started?</h3>
              <p>Visit us at Kashmir Road Shop 128-B, Saddar Rawalpindi or contact us today.</p>
              <div className="tw-page-cta-btns">
                <a href="tel:03003456447" className="tw-hero-btn"><i className="fas fa-phone"></i> Call Us Now</a>
                <a href="https://wa.me/923003456447" target="_blank" rel="noopener noreferrer" className="tw-hero-btn-outline"><i className="fab fa-whatsapp"></i> WhatsApp</a>
                <button className="tw-hero-btn-outline" onClick={() => { setCurrentPage(null); window.scrollTo({top:0,behavior:'smooth'}); }}><i className="fas fa-home"></i> Back to Home</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="tw-dark">
      {/* ====== SEARCH OVERLAY ====== */}
      {searchOpen && (
        <div className="tw-search-overlay" onClick={closeSearch}>
          <div className="tw-search-modal" onClick={e => e.stopPropagation()}>
            <div className="tw-search-input-wrap">
              <i className="fas fa-search"></i>
              <input
                ref={searchInputRef}
                type="text"
                placeholder="Search tires by brand or size..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
              />
              <button className="tw-search-close" onClick={closeSearch} title="Close">
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="tw-search-results">
              <div className="tw-search-results-label">
                {searchQuery.trim()
                  ? `${searchResults.length} result${searchResults.length !== 1 ? 's' : ''} for "${searchQuery}"`
                  : `All Products — tires in stock`
                }
              </div>
              {searchResults.length > 0 ? (
                <div className="tw-search-grid">
                  {searchResults.map((r, i) => (
                    <div key={i} className="tw-search-product-card" onClick={() => handleSearchClick(r)}>
                      <div className="tw-search-product-img">
                        <img src={r.img} alt={r.title} />
                      </div>
                      <div className="tw-search-product-info">
                        <span className="tw-search-product-brand">{r.type}</span>
                        <div className="tw-sr-title">{r.title}</div>
                        <span className="tw-search-product-cta">View Details <i className="fas fa-arrow-right"></i></span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="tw-search-no-result">No tires found for "<strong>{searchQuery}</strong>"</div>
              )}
            </div>
          </div>
        </div>
      )}
      {/* ====== HERO SLIDER (full viewport — topbar & navbar float over video) ====== */}
      {currentPage ? (<>
        {/* Topbar & Navbar for inner pages */}
        <header className="tw-topbar">
          <div className="tw-topbar-inner">
            <div className="tw-logo">
              <button className="tw-logo-btn" onClick={() => { setCurrentPage(null); window.scrollTo({top:0,behavior:'smooth'}); }}><img src={LOGO} alt="Tires & Wheels" /></button>
            </div>
            <div className="tw-contact-info">
              <a href="tel:03003456447" className="tw-info-item tw-info-link">
                <i className="fas fa-phone"></i>
                <div><strong>Call us Now</strong><span>0300-3456447</span></div>
              </a>
              <div className="tw-info-item">
                <i className="fas fa-map-marker-alt"></i>
                <div><strong>Kashmir Road, Shop 128-B</strong><span>Saddar, Rawalpindi</span></div>
              </div>
              <div className="tw-info-item">
                <i className="far fa-clock"></i>
                <div><strong>Opening Times</strong><span>9 AM - 9 PM</span></div>
              </div>
            </div>
          </div>
        </header>
        <nav className="tw-navbar tw-navbar-static">
          <div className="tw-nav-inner">
            <ul className="tw-nav-links">
              {NAV_ITEMS.map(item => (
                <li key={item.label}>
                  <a href={item.href} className={item.label === 'HOME' ? 'active' : ''}
                    onClick={e => { if(item.label === 'HOME'){ e.preventDefault(); setCurrentPage(null); window.scrollTo({top:0,behavior:'smooth'}); } }}>
                    {item.label}{item.drop && <i className="fas fa-chevron-down"></i>}
                  </a>
                  {item.drop && (
                    <ul className="tw-dropdown">
                      {item.drop.map(d => (
                        <li key={d.page}>
                          <button className="tw-dropdown-btn" onClick={() => { setCurrentPage(d.page); window.scrollTo({top:0,behavior:'smooth'}); }}>
                            {d.label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
            <div className="tw-nav-icons">
              <button className="tw-icon-btn" onClick={openSearch} title="Search"><i className="fas fa-search"></i></button>
            </div>
            <button className="tw-mobile-btn" onClick={() => setMobileOpen(o => !o)}>
              <i className={mobileOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
            </button>
          </div>
          <div className={`tw-mobile-nav${mobileOpen ? ' open' : ''}`}>
            <ul>
              {NAV_ITEMS.map(item => (
                <li key={item.label}>
                  <a href={item.href} onClick={e => {
                    if (item.drop) { e.preventDefault(); setMobileDropOpen(o => ({...o, [item.label]: !o[item.label]})); }
                    else if (item.label === 'HOME') { e.preventDefault(); setCurrentPage(null); setMobileOpen(false); window.scrollTo({top:0,behavior:'smooth'}); }
                    else setMobileOpen(false);
                  }}>
                    {item.label}
                    {item.drop && <i className={`fas fa-chevron-${mobileDropOpen[item.label] ? 'up' : 'down'}`} style={{marginLeft:8,fontSize:10,transition:'transform .2s'}}></i>}
                  </a>
                  {item.drop && mobileDropOpen[item.label] && (
                    <ul className="tw-mobile-submenu">
                      {item.drop.map(d => (
                        <li key={d.page}>
                          <button className="tw-mobile-submenu-btn" onClick={() => { setCurrentPage(d.page); setMobileOpen(false); setMobileDropOpen({}); window.scrollTo({top:0,behavior:'smooth'}); }}>
                            <i className="fas fa-chevron-right" style={{marginRight:6,fontSize:9,color:'#c9a84c'}}></i>{d.label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </nav>
        {renderPage()}
      </>) : (<>
      <section className="tw-hero" id="home">
        {/* Background Video — fills 100vh */}
        <video
          className="tw-hero-video"
          src="/Demo/Car_tire3.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="tw-slide-overlay" />

        {/* Topbar floating over video */}
        <header className="tw-topbar">
          <div className="tw-topbar-inner">
            <div className="tw-logo">
              <button className="tw-logo-btn" onClick={() => window.scrollTo({top:0,behavior:'smooth'})}><img src={LOGO} alt="Tires & Wheels" /></button>
            </div>
            <div className="tw-contact-info">
              <a href="tel:03003456447" className="tw-info-item tw-info-link">
                <i className="fas fa-phone"></i>
                <div><strong>Call us Now</strong><span>0300-3456447</span></div>
              </a>
              <div className="tw-info-item">
                <i className="fas fa-map-marker-alt"></i>
                <div><strong>Kashmir Road, Shop 128-B</strong><span>Saddar, Rawalpindi</span></div>
              </div>
              <div className="tw-info-item">
                <i className="far fa-clock"></i>
                <div><strong>Opening Times</strong><span>9 AM - 9 PM</span></div>
              </div>
            </div>
          </div>
        </header>

        {/* Navbar floating over video */}
        <nav className="tw-navbar">
          <div className="tw-nav-inner">
            <ul className="tw-nav-links">
              {NAV_ITEMS.map(item => (
                <li key={item.label}>
                  <a href={item.href} className={item.label === 'HOME' ? 'active' : ''}
                    onClick={e => { if(item.label === 'HOME'){ e.preventDefault(); setCurrentPage(null); window.scrollTo({top:0,behavior:'smooth'}); } }}>
                    {item.label}{item.drop && <i className="fas fa-chevron-down"></i>}
                  </a>
                  {item.drop && (
                    <ul className="tw-dropdown">
                      {item.drop.map(d => (
                        <li key={d.page}>
                          <button className="tw-dropdown-btn" onClick={() => { setCurrentPage(d.page); window.scrollTo({top:0,behavior:'smooth'}); }}>
                            {d.label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
            <div className="tw-nav-icons">
              <button className="tw-icon-btn" onClick={openSearch} title="Search"><i className="fas fa-search"></i></button>
            </div>
            <button className="tw-mobile-btn" onClick={() => setMobileOpen(o => !o)}>
              <i className={mobileOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
            </button>
          </div>
          <div className={`tw-mobile-nav${mobileOpen ? ' open' : ''}`}>
            <ul>
              {NAV_ITEMS.map(item => (
                <li key={item.label}>
                  <a href={item.href} onClick={e => {
                    if (item.drop) { e.preventDefault(); setMobileDropOpen(o => ({...o, [item.label]: !o[item.label]})); }
                    else if (item.label === 'HOME') { e.preventDefault(); setCurrentPage(null); setMobileOpen(false); window.scrollTo({top:0,behavior:'smooth'}); }
                    else setMobileOpen(false);
                  }}>
                    {item.label}
                    {item.drop && <i className={`fas fa-chevron-${mobileDropOpen[item.label] ? 'up' : 'down'}`} style={{marginLeft:8,fontSize:10}}></i>}
                  </a>
                  {item.drop && mobileDropOpen[item.label] && (
                    <ul className="tw-mobile-submenu">
                      {item.drop.map(d => (
                        <li key={d.page}>
                          <button className="tw-mobile-submenu-btn" onClick={() => { setCurrentPage(d.page); setMobileOpen(false); setMobileDropOpen({}); window.scrollTo({top:0,behavior:'smooth'}); }}>
                            <i className="fas fa-chevron-right" style={{marginRight:6,fontSize:9,color:'#c9a84c'}}></i>{d.label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </nav>

        <div className="tw-hero-content">
          <div className="tw-hero-cta">
            <p className="tw-hero-tagline">PREMIUM TIRES & WHEELS</p>
            <h1 className="tw-hero-heading">Imperial Tyres <span>#1</span></h1>
            <p className="tw-hero-sub">Rawalpindi's Most Trusted Tire & Wheel Specialists</p>
            <div className="tw-hero-btns">
              <a href="#products" className="tw-btn-hero-primary">
                <i className="fas fa-shopping-bag"></i> Shop Now
              </a>
              <a href="https://share.google/wxQBLBfxg5SEk1Ykm" target="_blank" rel="noopener noreferrer" className="tw-btn-hero-outline">
                <i className="fas fa-map-marker-alt"></i> Visit Our Shop
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ====== TIRE FINDER ====== */}
      <div className="tw-finder-bar">
        <div className="tw-container">
          <div className="tw-finder-inner">
            <img src={TIRE_DIAGRAM} alt="Tire Size" className="tw-tire-diagram-img" />
            <form className="tw-finder-row" onSubmit={handleFinder}>
              <div className="tw-finder-group">
                <label>Category</label>
                <div className="tw-custom-select" onClick={() => setFinderDrop(d => d==='brand' ? null : 'brand')}>
                  <span>{brandFilter === 'ALL' ? 'All Brands' : brandFilter}</span><i className={`fas fa-chevron-${finderDrop==='brand'?'up':'down'}`}></i>
                  {finderDrop==='brand' && (
                    <ul className="tw-custom-options" onClick={e => e.stopPropagation()}>
                      {['ALL','DUNLOP','YOKOHAMA','BRIDGESTONE','CONTINENTAL','CHINA'].map(b => (
                        <li key={b} className={brandFilter===b?'active':''} onClick={() => { setBrandFilter(b); setPatternFilter('ALL'); setFinderDrop(null); }}>
                          {b === 'ALL' ? 'All Brands' : b}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div className="tw-finder-group">
                <label>Tire Width</label>
                <div className="tw-custom-select" onClick={() => setFinderDrop(d => d==='width' ? null : 'width')}>
                  <span>{tireWidth}</span><i className={`fas fa-chevron-${finderDrop==='width'?'up':'down'}`}></i>
                  {finderDrop==='width' && (
                    <ul className="tw-custom-options" onClick={e => e.stopPropagation()}>
                      {TIRE_WIDTHS.map(w => <li key={w} className={tireWidth===String(w)?'active':''} onClick={() => { setTireWidth(String(w)); setFinderDrop(null); }}>{w}</li>)}
                    </ul>
                  )}
                </div>
              </div>
              <div className="tw-finder-group">
                <label>Aspect Ratio</label>
                <div className="tw-custom-select" onClick={() => setFinderDrop(d => d==='ratio' ? null : 'ratio')}>
                  <span>{aspectRatio}</span><i className={`fas fa-chevron-${finderDrop==='ratio'?'up':'down'}`}></i>
                  {finderDrop==='ratio' && (
                    <ul className="tw-custom-options" onClick={e => e.stopPropagation()}>
                      {ASPECT_RATIOS.map(r => <li key={r} className={aspectRatio===String(r)?'active':''} onClick={() => { setAspectRatio(String(r)); setFinderDrop(null); }}>{r}</li>)}
                    </ul>
                  )}
                </div>
              </div>
              <div className="tw-finder-group">
                <label>Rim Diameter</label>
                <div className="tw-custom-select" onClick={() => setFinderDrop(d => d==='rim' ? null : 'rim')}>
                  <span>{rimSize}</span><i className={`fas fa-chevron-${finderDrop==='rim'?'up':'down'}`}></i>
                  {finderDrop==='rim' && (
                    <ul className="tw-custom-options" onClick={e => e.stopPropagation()}>
                      {RIM_SIZES.map(r => <li key={r} className={rimSize===String(r)?'active':''} onClick={() => { setRimSize(String(r)); setFinderDrop(null); }}>{r}</li>)}
                    </ul>
                  )}
                </div>
              </div>
              <div className="tw-finder-group">
                <label>Pattern</label>
                <div className="tw-custom-select" onClick={() => setFinderDrop(d => d==='pattern' ? null : 'pattern')}>
                  <span>{patternFilter === 'ALL' ? 'All Patterns' : patternFilter}</span><i className={`fas fa-chevron-${finderDrop==='pattern'?'up':'down'}`}></i>
                  {finderDrop==='pattern' && (
                    <ul className="tw-custom-options" onClick={e => e.stopPropagation()}>
                      <li className={patternFilter==='ALL'?'active':''} onClick={() => { setPatternFilter('ALL'); setFinderDrop(null); }}>All Patterns</li>
                      {(brandFilter === 'ALL'
                        ? Object.values(BRAND_PATTERNS).flat()
                        : (BRAND_PATTERNS[brandFilter] || [])
                      ).map(pt => (
                        <li key={pt} className={patternFilter===pt?'active':''} onClick={() => { setPatternFilter(pt); setFinderDrop(null); }}>{pt}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <button type="submit" className="tw-btn-submit" onClick={() => setFinderDrop(null)}>Find Tires</button>
            </form>
          </div>
        </div>
      </div>

      {/* ====== TIRE CATEGORIES ====== */}
      <section className="tw-categories">
        <div className="tw-section-header">
          <span className="tw-section-sub">Our Brands</span>
          <h2 className="tw-section-title">TIRE BRANDS WE CARRY</h2>
        </div>
        <div className="tw-cat-grid">
          {BRAND_CATS.map(cat => (
            <div key={cat.name} className="tw-cat-card" style={{backgroundImage:`url('${cat.img}')`}}>
              <div className="tw-cat-info">
                <h3>{cat.name}</h3>
                <p>{cat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ====== ABOUT ====== */}
      <section className="tw-about" id="about">
        <div className="tw-container">
          <div className="tw-about-inner">
            <div className="tw-about-img">
              <img src={ABOUT_IMG} alt="Tires" />
            </div>
            <div className="tw-about-text">
              <span className="tw-about-sub">We provide a</span>
              <h2>OVER 500 TIRE TESTS TO ENSURE YOU GET THE PERFECT TIRE FOR YOUR VEHICLE.</h2>
              <p>
                Introducing Tires &amp; Wheels online store Real-world, independent tire tests in snow, ice,
                wet and dry conditions so you'll know exactly how they'll perform on the road. Whatever
                your budget and whatever the size of car you are looking for, we are sure we can help
                you find what's right for you.
              </p>
              <button className="tw-btn-gold" onClick={() => {}}>READ MORE</button>
            </div>
          </div>
        </div>
      </section>

      {/* ====== PRODUCTS ====== */}
      <section className="tw-products" id="products">
        <div className="tw-container">
          <div className="tw-section-header">
            <span className="tw-section-sub">IMPERIAL TYRES #1 — SADDAR RAWALPINDI</span>
            <h2 className="tw-section-title">OUR TIRE STOCK</h2>
          </div>
          <div className="tw-products-grid">
            {PRODUCTS.map(p => (
              <div className="tw-product-card" key={p.id}>
                <div className="tw-product-img-wrap">
                  <span className="tw-brand-badge">{p.brand}</span>
                  <img src={p.img} alt={p.name} />
                  <div className="tw-product-hover">
                    <button onClick={() => setQuickView(p)}><i className="fas fa-eye"></i> Quick View</button>
                  </div>
                </div>
                <div className="tw-product-info">
                  <div className="tw-product-name">{p.name}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ====== WHY US ====== */}
      <section className="tw-why" id="services">
        <div className="tw-why-left">
          <div className="tw-section-header" style={{textAlign:'left', marginBottom:'44px'}}>
            <span className="tw-section-sub">THE EXPERTS</span>
            <h2 className="tw-section-title" style={{textAlign:'left'}}>
              OVER 500 TIRE TESTS FOR YOUR VEHICLE
            </h2>
            <p style={{color:'#999', fontSize:'14px', lineHeight:'1.7'}}>
              Introducing Tires &amp; Wheels online store Real-world, independent tire tests in snow,
              ice, wet and dry conditions so you'll know exactly how they'll perform on the road.
            </p>
          </div>
          <div className="tw-why-features">
            {WHY_FEATURES.map(f => (
              <div className="tw-why-item" key={f.title}>
                <div className="tw-why-icon">
                  <img src={f.icon} alt={f.title} />
                </div>
                <div className="tw-why-content">
                  <h3>{f.title}</h3>
                  <p>{f.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="tw-why-right">
          <img
            src="https://themes.webdevia.com/tires-wheels/wp-content/uploads/revslider/dark_home/slide-1.jpg"
            alt="Tire Expert"
          />
        </div>
      </section>

      {/* ====== STATS BAR ====== */}
      <div ref={statsRef} style={{background:'#c9a84c', padding:'50px 0'}}>
        <div style={{maxWidth:'1200px', margin:'0 auto', padding:'0 20px', display:'grid', gridTemplateColumns:'repeat(4,1fr)', textAlign:'center'}}>
          {[{n:c1,l:'Happy Clients'},{n:c2,l:'Tire Tests'},{n:c3,l:'Years Experience'},{n:c4,l:'Expert Mechanics'}].map(s => (
            <div key={s.l} style={{borderRight:'1px solid rgba(0,0,0,.15)', padding:'10px 20px', lastChild:{borderRight:'none'}}}>
              <div style={{fontFamily:'Oswald,sans-serif', fontSize:'54px', fontWeight:'700', color:'#111', lineHeight:'1'}}>
                {s.n.toLocaleString()}<span style={{fontSize:'32px'}}>+</span>
              </div>
              <p style={{color:'#333', fontFamily:'Oswald,sans-serif', fontSize:'13px', fontWeight:'600', marginTop:'8px', letterSpacing:'2px', textTransform:'uppercase'}}>{s.l}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ====== VIDEO ====== */}
      <section className="tw-video-section">
        <div className="tw-video-inner">
          <div className="tw-section-header">
            <span className="tw-section-sub">THE EXPERTS</span>
            <h2 className="tw-section-title">VIDEO DEMO</h2>
          </div>
          <div className="tw-video-player-wrap">
            <button className="tw-vid-arrow tw-vid-prev" onClick={() => { setVidIdx(i => (i - 1 + 3) % 3); setVidPlaying(false); }}>
              <i className="fas fa-chevron-left"></i>
            </button>
            <div className="tw-video-main">
              <video
                key={vidIdx}
                className="tw-video-el"
                ref={videoRef}
                src={`/Demo/Car_tire${vidIdx === 0 ? '' : vidIdx}.mp4`}
                onClick={() => {
                  if (vidPlaying) { videoRef.current.pause(); setVidPlaying(false); }
                  else { videoRef.current.play(); setVidPlaying(true); }
                }}
              >
                Your browser does not support video.
              </video>
              {!vidPlaying && (
                <div className="tw-vid-play-overlay" onClick={() => { videoRef.current.play(); setVidPlaying(true); }}>
                  <div className="tw-vid-play-btn">
                    <i className="fas fa-play"></i>
                  </div>
                  <p className="tw-vid-overlay-label">Car Tire Demo {vidIdx + 1}</p>
                </div>
              )}
              <div className="tw-vid-dots">
                {[0,1,2].map(i => (
                  <button key={i} className={`tw-vid-dot${vidIdx === i ? ' active' : ''}`} onClick={() => { setVidIdx(i); setVidPlaying(false); }}></button>
                ))}
              </div>
            </div>
            <button className="tw-vid-arrow tw-vid-next" onClick={() => { setVidIdx(i => (i + 1) % 3); setVidPlaying(false); }}>
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
          <p className="tw-vid-label">Video {vidIdx + 1} / 3 — Click to play</p>
        </div>
      </section>

      {/* ====== BLOG ====== */}
      <section className="tw-blog" id="blog">
        <div className="tw-container">
          <div className="tw-section-header">
            <span className="tw-section-sub">THE JOURNAL</span>
            <h2 className="tw-section-title">RECENT BLOG POSTS</h2>
          </div>
          <div className="tw-blog-grid">
            {BLOG_POSTS.map(post => (
              <div className="tw-blog-card" key={post.id}>
                <div className="tw-blog-thumb-wrap">
                  <img className="tw-blog-thumb" src={post.img} alt={post.title} />
                  <span className="tw-blog-cat">{post.category}</span>
                </div>
                <div className="tw-blog-body">
                  <div className="tw-blog-meta">
                    <span><i className="far fa-calendar-alt"></i> {post.date}</span>
                    <span><i className="far fa-user"></i> {post.author}</span>
                  </div>
                  <h4>{post.title}</h4>
                  <p>{post.excerpt}</p>
                  <button className="tw-btn-read" onClick={() => { setBlogPost(post); window.scrollTo({top:0,behavior:'smooth'}); }}>READ MORE <i className="fas fa-arrow-right"></i></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ====== CONTACT US SECTION ====== */}
      <section className="tw-contact-section" id="contact-section">
        <div className="tw-container">
          <div className="tw-section-header">
            <span className="tw-section-sub">GET IN TOUCH</span>
            <h2 className="tw-section-title">CONTACT US</h2>
          </div>
          <div className="tw-contact-grid">
            <div className="tw-contact-cards-full">
              <div className="tw-contact-card">
                <div className="tw-contact-card-icon"><i className="fas fa-store"></i></div>
                <div>
                  <h4>Shop Name</h4>
                  <p>Imperial Tyres #1</p>
                </div>
              </div>
              <div className="tw-contact-card">
                <div className="tw-contact-card-icon"><i className="fas fa-phone"></i></div>
                <div>
                  <h4>Phone Number</h4>
                  <p><a href="tel:03003456447">0300-3456447</a></p>
                </div>
              </div>
              <div className="tw-contact-card">
                <div className="tw-contact-card-icon"><i className="fas fa-map-marker-alt"></i></div>
                <div>
                  <h4>Our Address</h4>
                  <p><a href="https://share.google/wxQBLBfxg5SEk1Ykm" target="_blank" rel="noopener noreferrer">Kashmir Road, Shop 128-B<br/>Saddar, Rawalpindi</a></p>
                </div>
              </div>
              <div className="tw-contact-card">
                <div className="tw-contact-card-icon"><i className="fas fa-envelope"></i></div>
                <div>
                  <h4>Email Address</h4>
                  <p><a href="mailto:Imperialtyres4@gmail.com">Imperialtyres4@gmail.com</a></p>
                </div>
              </div>
              <div className="tw-contact-card">
                <div className="tw-contact-card-icon"><i className="far fa-clock"></i></div>
                <div>
                  <h4>Working Hours</h4>
                  <p>Monday – Saturday<br/>9:00 AM – 9:00 PM</p>
                </div>
              </div>
            </div>
          </div>
          {/* Map bar */}
          <div className="tw-map-bar">
            <div className="tw-map-label">
              <i className="fas fa-map-marker-alt"></i>
              <span>Kashmir Road, Shop 128-B Saddar, Rawalpindi — <strong>Imperial Tyres #1</strong></span>
            </div>
            <a
              href="https://share.google/wxQBLBfxg5SEk1Ykm"
              target="_blank"
              rel="noopener noreferrer"
              className="tw-visit-btn"
            >
              <i className="fas fa-directions"></i> Visit Our Shop
            </a>
          </div>
        </div>
      </section>

      {/* ====== FOOTER ====== */}
      <footer className="tw-footer" id="contact">
        <div className="tw-footer-inner">
          <div className="tw-footer-col">
            <button className="tw-footer-logo" onClick={() => window.scrollTo({top:0,behavior:'smooth'})}>
              <img src={LOGO} alt="Imperial Tyres" />
            </button>
            <p style={{color:'#888', fontSize:'13px', lineHeight:'1.8', marginTop:'10px'}}>
              Imperial Tyres #1 — Your trusted tire &amp; wheel specialists in Rawalpindi. Quality products and professional service since day one.
            </p>
          </div>
          <div className="tw-footer-col tw-footer-contact">
            <h4>GET IN TOUCH</h4>
            <p><strong>PHONE:</strong> 0300-3456447</p>
            <p><strong>EMAIL:</strong> Imperialtyres4@gmail.com</p>
            <p><strong>ADDRESS:</strong> Kashmir Road, Shop 128-B Saddar, Rawalpindi</p>
            <p><strong>SHOP:</strong> Imperial Tyres #1</p>
            <p><strong>HOURS:</strong> 9 AM – 9 PM</p>
          </div>
          <div className="tw-footer-col">
            <h4>QUICK LINKS</h4>
            <ul className="tw-footer-links-list">
              <li><a href="#home"><i className="fas fa-chevron-right"></i> Home</a></li>
              <li><a href="#about"><i className="fas fa-chevron-right"></i> About Us</a></li>
              <li><a href="#services"><i className="fas fa-chevron-right"></i> Services</a></li>
              <li><a href="#products"><i className="fas fa-chevron-right"></i> Shop</a></li>
              <li><a href="#blog"><i className="fas fa-chevron-right"></i> Blog</a></li>
              <li><a href="#contact-section"><i className="fas fa-chevron-right"></i> Contact Us</a></li>
            </ul>
          </div>
        </div>
        <div className="tw-footer-bottom">
          <div className="tw-footer-bottom-links">
            <a href="#home">Home</a>
            <a href="#blog">Blog</a>
            <a href="#contact-section">Contact Us</a>
          </div>
          <p className="tw-copyright">&copy; {new Date().getFullYear()} Imperial Tyres #1. All rights reserved.</p>
        </div>
      </footer>
      </>)}

      {/* ====== BLOG POST READER ====== */}
      {blogPost && (
        <div className="tw-blog-reader-overlay" onClick={() => setBlogPost(null)}>
          <div className="tw-blog-reader" onClick={e => e.stopPropagation()}>
            <button className="tw-blog-reader-close" onClick={() => setBlogPost(null)}>
              <i className="fas fa-times"></i>
            </button>
            {/* Hero Image */}
            <div className="tw-blog-reader-hero" style={{backgroundImage:`url('${blogPost.img}')`}}>
              <div className="tw-blog-reader-hero-overlay"></div>
              <div className="tw-blog-reader-hero-content">
                <span className="tw-blog-cat">{blogPost.category}</span>
                <h1>{blogPost.title}</h1>
                <div className="tw-blog-reader-meta">
                  <span><i className="far fa-calendar-alt"></i> {blogPost.date}</span>
                  <span><i className="far fa-user"></i> {blogPost.author}</span>
                </div>
              </div>
            </div>
            {/* Article Body */}
            <div className="tw-blog-reader-body">
              {blogPost.content.map((block, i) => {
                if (block.type === 'p')    return <p key={i}>{block.text}</p>;
                if (block.type === 'h3')   return <h3 key={i}>{block.text}</h3>;
                if (block.type === 'list') return (
                  <ul key={i} className="tw-blog-reader-list">
                    {block.items.map((item, j) => <li key={j}><i className="fas fa-check-circle"></i>{item}</li>)}
                  </ul>
                );
                if (block.type === 'tip') return (
                  <div key={i} className="tw-blog-reader-tip">
                    <i className="fas fa-lightbulb"></i>
                    <span>{block.text}</span>
                  </div>
                );
                return null;
              })}
              {/* CTA at bottom */}
              <div className="tw-blog-reader-cta">
                <h4>Need Tires? Visit Imperial Tyres #1</h4>
                <p>Kashmir Road Shop 128-B, Saddar Rawalpindi &nbsp;|&nbsp; 0300-3456447</p>
                <div className="tw-blog-reader-cta-btns">
                  <a href="tel:03003456447" className="tw-hero-btn"><i className="fas fa-phone"></i> Call Now</a>
                  <a href="https://wa.me/923003456447" target="_blank" rel="noopener noreferrer" className="tw-hero-btn-outline"><i className="fab fa-whatsapp"></i> WhatsApp</a>
                  <button className="tw-hero-btn-outline" onClick={() => setBlogPost(null)}><i className="fas fa-arrow-left"></i> Back to Blog</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ====== FINDER RESULTS MODAL ====== */}
      {finderResults && (
        <div className="tw-qv-overlay" onClick={() => setFinderResults(null)}>
          <div className="tw-finder-modal" onClick={e => e.stopPropagation()}>
            <button className="tw-qv-close" onClick={() => setFinderResults(null)}>
              <i className="fas fa-times"></i>
            </button>
            <div className="tw-finder-modal-header">
              <i className="fas fa-search"></i>
              <div>
                <h2>Results for <span>{finderResults.size}</span>{finderResults.brand !== 'ALL' && <> — <span>{finderResults.brand}</span></>}{finderResults.pattern && finderResults.pattern !== 'ALL' && <> · <span>{finderResults.pattern}</span></>}</h2>
                <p>{finderResults.items.length > 0 ? `${finderResults.items.length} tire${finderResults.items.length !== 1 ? 's' : ''} found in our shop` : 'Available at our shop — contact us to order!'}</p>
              </div>
            </div>
            {finderResults.items.length === 0 ? (
              <div className="tw-finder-no-results">
                <i className="fas fa-check-circle" style={{color:'#c9a84c'}}></i>
                <h3>In Stock — Available at Our Shop!</h3>
                <p>Size <strong style={{color:'#c9a84c'}}>{finderResults.size}</strong> available hai hamare shop mai. Abhi contact karo aur order karo!</p>
                <div className="tw-finder-no-btns">
                  <a href="tel:03003456447" className="tw-qv-btn tw-qv-call"><i className="fas fa-phone"></i> Call Us Now</a>
                  <a href="https://wa.me/923003456447" target="_blank" rel="noopener noreferrer" className="tw-qv-btn tw-qv-wa"><i className="fab fa-whatsapp"></i> WhatsApp</a>
                  <a href="https://share.google/wxQBLBfxg5SEk1Ykm" target="_blank" rel="noopener noreferrer" className="tw-qv-btn tw-qv-visit"><i className="fas fa-store"></i> Visit Shop</a>
                </div>
              </div>
            ) : (
              <div className="tw-finder-results-grid">
                {finderResults.items.map(p => (
                  <div key={p.id} className="tw-finder-result-card" onClick={() => { setFinderResults(null); setQuickView(p); }}>
                    <div className="tw-finder-result-img">
                      <img src={p.img} alt={p.name} />
                    </div>
                    <div className="tw-finder-result-info">
                      <span className="tw-finder-result-brand">{p.brand}</span>
                      <h4>{p.name}</h4>
                      <div className="tw-finder-result-meta">
                        <span><i className="fas fa-check-circle"></i> In Stock</span>
                        <span><i className="fas fa-map-marker-alt"></i> Saddar, Rawalpindi</span>
                      </div>
                      <button className="tw-finder-result-btn">Quick View</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* ====== QUICK VIEW MODAL ====== */}
      {quickView && (
        <div className="tw-qv-overlay" onClick={() => setQuickView(null)}>
          <div className="tw-qv-modal" onClick={e => e.stopPropagation()}>
            <button className="tw-qv-close" onClick={() => setQuickView(null)}>
              <i className="fas fa-times"></i>
            </button>
            <div className="tw-qv-inner">
              <div className="tw-qv-img">
                <img src={quickView.img} alt={quickView.name} />
              </div>
              <div className="tw-qv-details">
                <span className="tw-qv-brand">{quickView.brand}</span>
                <h2 className="tw-qv-title">{quickView.name}</h2>
                <div className="tw-qv-divider"></div>
                <div className="tw-qv-info-row">
                  <i className="fas fa-check-circle"></i>
                  <span>In Stock — Available at our shop</span>
                </div>
                <div className="tw-qv-info-row">
                  <i className="fas fa-map-marker-alt"></i>
                  <span>Kashmir Road Shop 128-B, Saddar Rawalpindi</span>
                </div>
                <div className="tw-qv-info-row">
                  <i className="fas fa-phone"></i>
                  <span>0300-3456447</span>
                </div>
                <div className="tw-qv-actions">
                  <a href="tel:03003456447" className="tw-qv-btn tw-qv-call">
                    <i className="fas fa-phone"></i> Call to Order
                  </a>
                  <a href="https://wa.me/923003456447" target="_blank" rel="noopener noreferrer" className="tw-qv-btn tw-qv-wa">
                    <i className="fab fa-whatsapp"></i> WhatsApp
                  </a>
                  <a href="https://share.google/wxQBLBfxg5SEk1Ykm" target="_blank" rel="noopener noreferrer" className="tw-qv-btn tw-qv-visit">
                    <i className="fas fa-store"></i> Visit Shop
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ====== FLOATING CONTACT BUTTONS ====== */}
      <div className="tw-float-btns">
        <a href="https://wa.me/923003456447" target="_blank" rel="noopener noreferrer" className="tw-float-btn tw-float-whatsapp" title="WhatsApp Us">
          <i className="fab fa-whatsapp"></i>
          <span>WhatsApp</span>
        </a>
        <a href="tel:03003456447" className="tw-float-btn tw-float-call" title="Call Us">
          <i className="fas fa-phone"></i>
          <span>Call Now</span>
        </a>
      </div>

      {/* ====== SCROLL TOP ====== */}
      <button
        className={`tw-scroll-top${showScrollTop ? ' show' : ''}`}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <i className="fas fa-chevron-up"></i>
      </button>
    </div>
  );
}

